import { isCI } from '../utils';
export function artifactId(override) {
    const artifactIdToUse = process.env.ARTIFACT_ID ?? process.env.APP_NAME ?? '';
    return {
        'X-Wix-Client-Artifact-Id': override ?? (!isCI() ? artifactIdToUse : ''),
    };
}
//# sourceMappingURL=artifact-id.js.map